import { SimpleGenList } from '../simpleGenList';

/**
 * Enumerated words for 'B' in Czech.
 */
export class GenList_EnumeratedWords__B extends SimpleGenList {
  constructor() {
    super(
      'být',
      'bydlit',
      'obyvatel',
      'byt',
      'příbytek',
      'nábytek',
      'dobytek',
      'obyčej',
      'bystrý',
      'bylina',
      'kobyla',
      'býk',
      'babyka'
    );
  }
}

/**
 * Enumerated words for 'L' in Czech.
 */
export class GenList_EnumeratedWords__L extends SimpleGenList {
  constructor() {
    super(
      'slyšet',
      'mlýn',
      'blýskat se',
      'polykat',
      'plynout',
      'plýtvat',
      'vzlykat',
      'lysý',
      'lýko',
      'lýtko',
      'lyže',
      'pelyněk',
      'plyš'
    );
  }
}

/**
 * Enumerated words for 'M' in Czech.
 */
export class GenList_EnumeratedWords__M extends SimpleGenList {
  constructor() {
    super(
      'my',
      'mýt',
      'myslit',
      'mýlit se',
      'hmyz',
      'myš',
      'hlemýžď',
      'mýtit',
      'zamykat',
      'smýkat',
      'dmýchat',
      'chmýří',
      'nachomýtnout se'
    );
  }
}

/**
 * Enumerated words for 'P' in Czech.
 */
export class GenList_EnumeratedWords__P extends SimpleGenList {
  constructor() {
    super(
      'pýcha',
      'pytel',
      'pysk',
      'netopýr',
      'slepýš',
      'pyl',
      'kopyto',
      'klopýtat',
      'třpytit se',
      'zpytovat',
      'pykat',
      'pýr',
      'pýřit se',
      'čepýřit se'
    );
  }
}

/**
 * Enumerated words for 'S' in Czech.
 */
export class GenList_EnumeratedWords__S extends SimpleGenList {
  constructor() {
    super(
      'syn',
      'sytý',
      'sýr',
      'syrový',
      'sychravý',
      'usychat',
      'sýkora',
      'sýček',
      'sysel',
      'syčet',
      'sypat'
    );
  }
}

/**
 * Enumerated words for 'V' in Czech.
 */
export class GenList_EnumeratedWords__V extends SimpleGenList {
  constructor() {
    super(
      'vy',
      'vysoký',
      'výt',
      'výskat',
      'zvykat',
      'žvýkat',
      'vydra',
      'výr',
      'vyžle',
      'povyk',
      'výheň'
    );
  }
}

/**
 * Enumerated words for 'Z' in Czech.
 */
export class GenList_EnumeratedWords__Z extends SimpleGenList {
  constructor() {
    super('brzy', 'jazyk', 'nazývat', 'Ruzyně');
  }
}
